




































import Vue from 'vue';
import { mapActions, mapMutations } from 'vuex';
import { Component, Watch } from 'vue-property-decorator'

type ActionFunc = (arg: any) => void;
interface LogicControlForm {
    name: string | null;
    category: any;
    description: string | null;
    logic: any[];
}

@Component({
    methods: {
        ...mapActions('logic-control', { addLogic: 'create' }),
        ...mapMutations('bh-flow', { hideProperties: 'hide' })
    }
})
export default class DialogAddLogic extends Vue {
    dialog = false;
    loading = false;
    logicForm: LogicControlForm = {
        name: null,
        category: null,
        description: null,
        logic: []
    };

    addLogic!: ActionFunc;
    hideProperties: any;

    @Watch('dialog')
    ResetForm(nv: boolean) {
        if(nv) {
            this.hideProperties();
            this.logicForm = {
                name: null,
                category: null,
                description: null,
                logic: [
                    { module: 'payload', name: 'HTTP', props: {
                        return: '$context'
                    } }
                ]
            };
        }
    }

    public async addNewLogicControl() {
        try {
            this.loading = true;
            await this.addLogic({
                category_id: this.logicForm.category.id,
                name: this.logicForm.name,
                alias: (this.logicForm.name || '').toLowerCase().replace(/\W/g, '-').replace(/-+/g, '-'),
                description: this.logicForm.description,
                logic: JSON.stringify(this.logicForm.logic)
            });
            this.dialog = false;
            this.hideProperties();
            this.$emit('success');
        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.loading = false;
        }
    }
}
